export type ICols = 'xs1' | 'xs2' | 'xs3' | 'xs4' | 'xs5' | 'xs6' | 'xs7' | 'xs8' | 'xs9' | 'xs10' | 'xs11' | 'xs12' | 'sm1' | 'sm2' | 'sm3' | 'sm4' | 'sm5' | 'sm6' | 'sm7' | 'sm8' | 'sm9' | 'sm10' | 'sm11' | 'sm12' | 'md1' | 'md2' | 'md3' | 'md4' | 'md5' | 'md6' | 'md7' | 'md8' | 'md9' | 'md10' | 'md11' | 'md12' | 'lg1' | 'lg2' | 'lg3' | 'lg4' | 'lg5' | 'lg6' | 'lg7' | 'lg8' | 'lg9' | 'lg10' | 'lg11' | 'lg12' | 'xl1' | 'xl2' | 'xl3' | 'xl4' | 'xl5' | 'xl6' | 'xl7' | 'xl8' | 'xl9' | 'xl10' | 'xl11' | 'xl12'  | 'xx1' | 'xx2' | 'xx3' | 'xx4' | 'xx5' | 'xx6' | 'xx7' | 'xx8' | 'xx9' | 'xx10' | 'xx11' | 'xx12' | (string &  { fromT?: any});

export const ColSpans = {
    xs1:  'col-span-1',
    xs2:  'col-span-2',
    xs3:  'col-span-3',
    xs4:  'col-span-4',
    xs5:  'col-span-5',
    xs6:  'col-span-6',
    xs7:  'col-span-7',
    xs8:  'col-span-8',
    xs9:  'col-span-9',
    xs10: 'col-span-10',
    xs11: 'col-span-11',
    xs12: 'col-span-12',
    sm1:  'sm:col-span-1',
    sm2:  'sm:col-span-2',
    sm3:  'sm:col-span-3',
    sm4:  'sm:col-span-4',
    sm5:  'sm:col-span-5',
    sm6:  'sm:col-span-6',
    sm7:  'sm:col-span-7',
    sm8:  'sm:col-span-8',
    sm9:  'sm:col-span-9',
    sm10: 'sm:col-span-10',
    sm11: 'sm:col-span-11',
    sm12: 'sm:col-span-12',
    md1:  'md:col-span-1',
    md2:  'md:col-span-2',
    md3:  'md:col-span-3',
    md4:  'md:col-span-4',
    md5:  'md:col-span-5',
    md6:  'md:col-span-6',
    md7:  'md:col-span-7',
    md8:  'md:col-span-8',
    md9:  'md:col-span-9',
    md10: 'md:col-span-10',
    md11: 'md:col-span-11',
    md12: 'md:col-span-12',
    lg1:  'lg:col-span-1',
    lg2:  'lg:col-span-2',
    lg3:  'lg:col-span-3',
    lg4:  'lg:col-span-4',
    lg5:  'lg:col-span-5',
    lg6:  'lg:col-span-6',
    lg7:  'lg:col-span-7',
    lg8:  'lg:col-span-8',
    lg9:  'lg:col-span-9',
    lg10: 'lg:col-span-10',
    lg11: 'lg:col-span-11',
    lg12: 'lg:col-span-12',
    xl1:  'xl:col-span-1',
    xl2:  'xl:col-span-2',
    xl3:  'xl:col-span-3',
    xl4:  'xl:col-span-4',
    xl5:  'xl:col-span-5',
    xl6:  'xl:col-span-6',
    xl7:  'xl:col-span-7',
    xl8:  'xl:col-span-8',
    xl9:  'xl:col-span-9',
    xl10: 'xl:col-span-10',
    xl11: 'xl:col-span-11',
    xl12: 'xl:col-span-12',
    xx1:  '2xl:col-span-1',
    xx2:  '2xl:col-span-2',
    xx3:  '2xl:col-span-3',
    xx4:  '2xl:col-span-4',
    xx5:  '2xl:col-span-5',
    xx6:  '2xl:col-span-6',
    xx7:  '2xl:col-span-7',
    xx8:  '2xl:col-span-8',
    xx9:  '2xl:col-span-9',
    xx10: '2xl:col-span-10',
    xx11: '2xl:col-span-11',
    xx12: '2xl:col-span-12',
}